export default __webpack_public_path__ + "static/media/bbp-scheduler-modal-large.748837a5.png";